function getTopScrollValue(document: Document): number {
  if (document.documentElement) {
    return document.documentElement.scrollTop;
  }

  if (document.body) {
    return document.body.scrollTop;
  }

  return 0;
}

let instances = 0;

function lockBodyScroll(document: Document) {
  if (document.body) {
    ++instances;
    // We add a "z-index: 0" on body to better handle portals on IE11
    document.body.setAttribute(
      'style',
      `overflow: hidden; position:fixed !important; top: -${getTopScrollValue(document)}px;width: 100%;z-index:0;`,
    );
  }
}

function resumeBodyScroll(document: Document, previousPosition: number) {
  if (document.body && --instances === 0) {
    document.body.setAttribute('style', '');
  }

  if (document.body && previousPosition !== 0) {
    document.body.scrollTop = previousPosition;
  }

  if (document.documentElement && previousPosition !== 0) {
    document.documentElement.scrollTop = previousPosition;
  }
}

export { getTopScrollValue, lockBodyScroll, resumeBodyScroll };
